import React, { useEffect, useRef, useState } from 'react';
import {
  CRow,
  CCol,
  CButton,
  CTable,
  CTableHead,
  CTableHeaderCell,
  CTableBody,
  CTableRow,
  CTableDataCell,
} from '@coreui/react';
import adminApi from 'services/adminApi';
import ModalConfirm from '../../components/ModalConfirm';

const BackupData = () => {
  const [data, setData] = useState([]);
  const refModalConfirm = useRef(null);

  const getListData = async () => {
    const res = await adminApi({ url: '/backup', method: 'GET' });
    const result = await res.json();
    setData(result.data);
  };

  const handleClickRestore = async (id) => {
    refModalConfirm.current.open({
      title: 'Restore Data',
      description:
        'Are you sure you want to restore this data?\n This action will overwrite the current data.',
      dataConfirm: id,
    });
  };

  const handleConfirmRestore = async (id) => {
    console.log('🚀 ~ handleConfirmRestore ~ id:', id);
    const res = await adminApi({
      url: `/backup`,
      method: 'POST',
      body: {
        backupFile: id,
      },
    });
    const { isSuccess, message } = await res.json();
    if (!isSuccess) {
      alert(message);
    }
    refModalConfirm.current.close();
  };

  useEffect(() => {
    getListData();
  }, []);

  return (
    <div className="admin-table">
      <CRow className="my-2">
        <CCol className="text-end">
          <CButton
            className="create-btn"
            style={{ fontSize: '12px' }}
            color="success"
            hidden
          >
            Create New
          </CButton>
        </CCol>
      </CRow>

      <div
        style={{
          padding: '15px 25px',
          backgroundColor: 'white',
          borderRadius: '5px',
          overflowX: 'auto',
        }}
      >
        <CTable className="bg-dark" style={{ fontSize: '13px' }}>
          <CTableHead>
            <CTableRow>
              <CTableHeaderCell className="align-middle">#</CTableHeaderCell>
              <CTableHeaderCell className="align-middle">Name</CTableHeaderCell>
              <CTableHeaderCell
                className="align-middle"
                style={{ width: '150px' }}
              >
                Action
              </CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {data.map((item, index) => (
              <CTableRow key={item}>
                <CTableHeaderCell scope="row" className="align-middle">
                  {index + 1}
                </CTableHeaderCell>
                <CTableDataCell className="align-middle">{item}</CTableDataCell>
                <CTableDataCell className="align-middle d-flex">
                  <CButton
                    className="edit-btn me-2"
                    color="info"
                    style={{ fontSize: '12px' }}
                    onClick={() => handleClickRestore(item)}
                  >
                    Restore
                  </CButton>
                </CTableDataCell>
              </CTableRow>
            ))}
          </CTableBody>
        </CTable>
      </div>
      <ModalConfirm ref={refModalConfirm} onConfirm={handleConfirmRestore} />
    </div>
  );
};

export default BackupData;
